import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Icon } from '@iconify/react';

export default function PhotoMyPageModal({
  show,
  onClose,
  userName,
  userCoins,
  isHistoryLoading,
  historyError,
  imageHistory,
  deletedImageIds,
  onDeleteImage,
  onSelectImage,
  onOpenCs,
  onOpenPrivacy,
  onOpenTerms,
  onLogout,
}) {
  const visibleItems = Array.isArray(imageHistory)
    ? imageHistory.filter((item) => item && item.id && !deletedImageIds.includes(item.id))
    : [];

  const historyGridClassName =
    visibleItems.length === 1
      ? 'photo-mypage-history-grid is-1'
      : visibleItems.length === 2
        ? 'photo-mypage-history-grid is-2'
        : 'photo-mypage-history-grid';

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="photo-mypage-popup-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="photo-mypage-popup"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="photo-mypage-popup-header">
              <h3 className="photo-mypage-popup-title">마이페이지</h3>
              <button className="photo-mypage-popup-close" onClick={onClose}>
                <Icon icon="solar:close-circle-bold" width={20} height={20} />
              </button>
            </div>

            <div className="photo-mypage-popup-content">
              <div className="photo-mypage-section">
                <div className="photo-mypage-user-info">
                  <div className="photo-mypage-avatar-large">{String(userName || 'U').charAt(0).toUpperCase()}</div>
                  <div className="photo-mypage-user-details">
                    <h4 className="photo-mypage-user-name">{userName}</h4>
                    <div className="photo-mypage-coins">
                      <span className="coins-icon">🪙</span>
                      <span className="coins-amount">보유 코인: {userCoins}coin</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="photo-mypage-section">
                <h4 className="photo-mypage-section-title">생성한 이미지 히스토리</h4>
                {isHistoryLoading ? (
                  <div className="photo-mypage-empty-history">
                    <p>히스토리를 불러오는 중...</p>
                  </div>
                ) : historyError ? (
                  <div className="photo-mypage-empty-history">
                    <p>{historyError}</p>
                  </div>
                ) : visibleItems.length > 0 ? (
                  <div className={historyGridClassName}>
                    {visibleItems.map((item) => (
                      <div key={item.id} className="photo-mypage-history-item">
                        <button
                          className="photo-mypage-history-delete-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            onDeleteImage(item.id);
                          }}
                          aria-label="이미지 삭제"
                        >
                          <Icon icon="solar:trash-bin-trash-bold" width={16} height={16} />
                        </button>
                        <img
                          src={item.url}
                          alt={`${item.occasion} - ${item.meme}`}
                          className="photo-mypage-history-image"
                          onClick={() => onSelectImage(item.url)}
                        />
                        <div className="photo-mypage-history-info">
                          <span className="history-occasion">{item.occasion}</span>
                          {item.customText && <span className="history-text">{item.customText}</span>}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="photo-mypage-empty-history">
                    <p>생성한 이미지가 없습니다.</p>
                  </div>
                )}
              </div>

              <div className="photo-mypage-section">
                <div className="photo-mypage-menu">
                  <button className="photo-mypage-menu-item" onClick={onOpenCs}>
                    <span className="menu-icon">💬</span>
                    <span>고객센터 문의</span>
                  </button>
                  <button type="button" className="photo-mypage-menu-item" onClick={onOpenPrivacy}>
                    <span className="menu-icon">🔒</span>
                    <span>개인정보 사용 방침</span>
                  </button>
                  <button type="button" className="photo-mypage-menu-item" onClick={onOpenTerms}>
                    <span className="menu-icon">📄</span>
                    <span>약관 확인</span>
                  </button>
                  <button className="photo-mypage-menu-item logout" onClick={onLogout}>
                    <span className="menu-icon">🚪</span>
                    <span>로그아웃</span>
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}


